import script from "./toolbar-button-end-human-service.vue?vue&type=script&lang=ts&setup=true"
export * from "./toolbar-button-end-human-service.vue?vue&type=script&lang=ts&setup=true"

import "./toolbar-button-end-human-service.vue?vue&type=style&index=0&id=7f1522ea&lang=css"

const __exports__ = script;

export default __exports__